import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import Toaster from "@meforma/vue-toaster";
import wb from "./registerServiceWorker";

const app = createApp(App).use(router).use(Toaster);
app.provide('$workbox', wb);
app.mount('#app');